module.exports = __webpack_public_path__ + "SP_SPT2-Kites-f614f7797a8450c881fefc7de72ed79e.png";